import { BaseCoreGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/BaseCoreGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';

import { GameStore } from '../../../store/GameStore';

export class GameComunicationCashOutErrorProcessor extends BaseCoreGameCommunicationProcessor {
  messageName = 'cashoutError';
  delay = 0;

  process(message: GameCommunicationMessageType, store: GameStore): void {
    const processDelay: number = 0;
    setTimeout(() => {
      this.handleBetsStats(message, store);
    }, processDelay);
  }

  private handleBetsStats(message: GameCommunicationMessageType, store: GameStore): void {
    // show game over pop up
  }
}
